import React, { useCallback } from 'react'
import { Typography } from '@astrid/components'
import { ShelfCarousel } from 'components/ShelfCarousel'
import { BookMode } from 'store/services/Book'
import { LearningJourneyEntityType } from 'store/services/Journey'
import {
  getBookMode,
  getShelfKey,
  getShelfSectionKey,
  Shelf,
  ShelfSection as ShelfSectionType,
  StoreShelfEntry,
  StoreShelfSection
} from 'store/services/Library'

type ShelfSectionProps = {
  shelf: Shelf
  shelfRef: (element: HTMLElement | null) => HTMLElement | null
  shelfSection: StoreShelfSection
  handleItemClick: (item: StoreShelfEntry, bookMode: BookMode, shelfSource?: string) => void
  onEndReached: (shelfSection: ShelfSectionType) => Promise<void>
}

export const ShelfSection = ({ shelf, shelfSection, shelfRef, onEndReached, handleItemClick }: ShelfSectionProps) => {
  const sectionName = shelfSection.title
  const shouldShowSectionName = shelfSection.entries.length && sectionName

  const onItemClick = useCallback(
    (item: StoreShelfEntry) => {
      const bookType = item.type === LearningJourneyEntityType.Book ? item.data.type : undefined
      const bookMode = getBookMode({
        bookType: bookType,
        shelfType: shelf.type,
        shelfSectionType: shelfSection.type
      })
      return handleItemClick(item, bookMode, shelf.title || shelf.type)
    },
    [handleItemClick, shelf.type, shelf.title, shelfSection.type]
  )

  const onEndReached_ = async () => {
    try {
      await onEndReached(shelfSection)
    } catch (error) {}
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {shouldShowSectionName ? (
        <Typography variant="h4" style={{ margin: 0, fontSize: 18, fontWeight: 600, paddingLeft: 40 }}>
          {sectionName}
        </Typography>
      ) : null}
      <ShelfCarousel
        shelfRef={shelfRef}
        hasAfter={shelfSection.page.hasAfter}
        itemKeyPrefix={`${getShelfKey(shelf)}-${getShelfSectionKey(shelfSection)}`}
        items={shelfSection.entries}
        onItemClick={onItemClick}
        onEndReached={onEndReached_}
      />
    </div>
  )
}
